import { Button, Card, CardBody, Flex, Heading, Icon, Link, Stack, Text } from '@chakra-ui/react';
import { HiExternalLink } from 'react-icons/hi';

import { CopyButton } from '../CopyButton';

type Props = {
  instructions: string;
  termsAndConditionsUri?: string;
};

export const InstructionsCard = ({ instructions, termsAndConditionsUri }: Props) => {
  return (
    <Card h="auto" px="4" py="3" role="group">
      <CardBody p="0">
        <Stack spacing="3">
          <Flex justifyContent="space-between" alignItems="center">
            <Heading variant="h5">Instructions</Heading>
            <CopyButton text={instructions} />
          </Flex>
          <Text textStyle="bodyRegular" whiteSpace="pre-line">
            {instructions}
          </Text>
          {termsAndConditionsUri && (
            <Button
              variant="link"
              rightIcon={<Icon as={HiExternalLink} />}
              as={Link}
              isExternal
              target="_blank"
              colorScheme="primary"
              href={termsAndConditionsUri}
            >
              Airline Conditions of Contract
            </Button>
          )}
        </Stack>
      </CardBody>
    </Card>
  );
};
